import httpClient from '@zageno/rest-client';
import { User } from './models';

export async function getCurrentUser() {
  return httpClient.get<User>('/z20api/api/z20/current_user');
}

export function setUser(accessToken: string, idToken: string) {
  return httpClient.post(
    '/z20api/api/z20/current_user',
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'x-id-token': idToken,
        'x-z20': true,
      },
    },
  );
}

export function logoutUser(accessToken: string, idToken: string) {
  return httpClient.post(
    '/z20api/api/z20/logout_user',
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'x-id-token': idToken,
        'x-z20': true,
      },
    },
  );
}
